import { IEnvironment } from 'relay-runtime';
import { Navigate, RouteObject } from 'react-router-dom';

import { ErrorContainer } from 'shared-ui';

import { RoutingContext } from '../../../routing';
import {
  routeId as identityUserRouteId,
  loader as identityUserLoader,
  IdentityUserGroupLink,
  IdentityUserLayout,
} from './IdentityUserLayout';
import { createRoute as createDetails } from './IdentityUserDetails';

export const createIdentityUserRoutes = (
  routePrefix: string,
  environment: IEnvironment,
  context: RoutingContext,
  showHeader = true,
  inList = true,
): Array<RouteObject> => {
  const routeId = `${routePrefix}-${identityUserRouteId}`;

  return [
    {
      path: '*',
      id: routeId,
      element: <IdentityUserLayout inList={inList} showHeader={showHeader} />,
      errorElement: <ErrorContainer />,
      handle: {
        crumb: () => <IdentityUserGroupLink routeId={routeId} />,
      },
      loader: ({ params }) => {
        return identityUserLoader(environment, params);
      },
      children: [
        createDetails(routePrefix, environment),
        {
          path: '*',
          element: <Navigate to={'details'} replace />,
        },
      ],
    },
  ];
};
